// extracted by mini-css-extract-plugin
export default {"statsBox":"BasePeriodTable_statsBox__apCt7"};